export interface IEntryReasonPayload {
    ScanProblem: number;
    ChangeReason: number;
}

export interface IResolveEntryReasonParams {
    problemId?: number | null;
    resonId?: number | null;
    latchedProblemId?: number | null;
    latchedResonId?: number | null;
    isWeightCalculation?: boolean | null;
}

// Приоритет причины: аргумент → залоченное значение → 0.
// Спец-кейс התאמת משקל: isWeightCalculation && reson === 1 → { 0, 0 }.
export const resolveEntryReason = ({
    problemId,
    resonId,
    latchedProblemId,
    latchedResonId,
    isWeightCalculation,
}: IResolveEntryReasonParams): IEntryReasonPayload => {
    const reson = resonId ?? latchedResonId ?? 0
    const problem = problemId ?? latchedProblemId ?? 0
    if (isWeightCalculation && reson === 1) {
        return { ScanProblem: 0, ChangeReason: 0 }
    }
    return { ScanProblem: problem || 0, ChangeReason: reson || 0 }
}
